module.exports = __webpack_public_path__ + "img/custom.18c4cdf9.png";